// extracted by mini-css-extract-plugin
module.exports = {"variant-conflicts-used-notifications":"VariantConflictsUsedNotifications_variant-conflicts-used-notifications__PGlv_"};